import { render, staticRenderFns } from "./TdsReport.vue?vue&type=template&id=38a28860"
import script from "./TdsReport.vue?vue&type=script&lang=js"
export * from "./TdsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports